import {Avatar} from '@components/ui/avatar'
import {FC} from 'react'
import {User} from '@features/user/types.ts'

export const UserCard: FC<{user: User}> = ({user}) => {
    return (
        <div className="flex w-full items-center gap-3 px-3 py-4">
            <Avatar name={user.firstName} imageUrl={user.profilePhotoUrl ?? ''} />
            <div className="flex flex-col gap-0.5">
                <span className="text-sm font-medium">{user.firstName}</span>
                <small className="text-sm text-neutral-500">{user.email}</small>
            </div>
        </div>
    )
}
